<nz-card [nzTitle]="timelineTitle" class="glass-card h-auto shadow-lg border-0" aria-label="Trip Timeline"
    [nzBodyStyle]="{ padding: '1.5rem', overflowY: 'auto', overflowX: 'hidden', maxHeight: '38dvh', scrollbarWidth: 'none'}">
    <nz-timeline>
        <nz-timeline-item *ngFor="let leg of sequencedLegs; let i = index; let last = last; let first = first"
            [nzDot]="first ? firstLegTemplate : leg.status === 'active' || leg.status === 'paused' ? activeLegTemplate : leg?.status === 'completed' ? completedLegTemplate : leg?.status === 'discard' ? discardLegTemplate : ''">
            <ng-container *ngIf="leg.isSender">
                <div class="border border-blue-300 bg-blue-50 rounded-lg h-auto p-2" [title]="leg?.location.display_name">
                    <div class="flex items-center justify-between w-full text-xs gap-x-2">
                        <span class="truncate font-semibold text-gray-800 max-w-[180px]">{{ leg?.location.display_name }}</span>
                        <span class="text-gray-500" *ngIf="leg?.start_date">
                            <i nz-icon nzType="calendar" nzTheme="outline" class="mr-1"></i>
                            <span> {{ leg?.start_date | gDate:'dd/MM/yyyy hh:mm a' }} </span>
                        </span>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!leg.isSender">
                <div class="rounded-lg p-2 border"
                  [ngClass]="leg?.status === 'completed' ? 'bg-emerald-50 border-emerald-400 shadow-emerald-100' : leg?.status === 'discard' ? 'bg-red-50 border-red-400 shadow-red-100': 'bg-amber-50 border-amber-400 shadow-amber-100'">
                    <div class="flex flex-col justify-between h-full" >
                        <div class="flex items-center justify-between w-full">
                            <div class="flex items-center justify-between w-full text-xs">
                                <span class="truncate font-semibold text-gray-800 max-w-[180px]">{{
                                    leg?.location.display_name }}</span>
                                <ng-container *ngIf="beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg) === 'completed'">
                                    <span class="text-gray-500">
                                        <i nz-icon nzType="calendar" nzTheme="outline" class="mr-1"></i>
                                        <span> {{ leg?.end_date | gDate:'dd/MM/yyyy hh:mm a' }} </span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg)">
                                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap bg-gray-100 border border-gray-300 shadow-sm text-gray-700">
                                        <span>{{ beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg) }}</span>
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="flex items-center justify-end gap-x-2 w-full"
                          [ngClass]="{'border-t border-gray-200 pt-2 mt-2': beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg) == 'Completed' || (beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg) == 'Next destination') || beUtil.tripsSvc.getLegStatus(leg, firstActiveLeg) === 'Movement in progress' && feUtil.roleService.hasAccess([0,1,2,5,6,7])} ">
                            <ng-container *ngIf="leg?.checklist && (leg?.checklist | keyvalue).length > 0">
                                <button nz-button nzType="default" nzSize="small" (click)="viewChecklist(leg?.checklist)">
                                    <i nz-icon nzType="file-text" nzTheme="outline"></i>
                                    View Checklists
                                </button>
                            </ng-container>
                            <ng-container
                                *ngIf="leg?.status === 'completed' && leg?.checklist && (leg?.checklist | keyvalue).length == 0 && feUtil.roleService.hasAccess([0,1,2,5,6,7])">
                                <button nz-button nzType="default" nzSize="small" (click)="openUploadChecklistsModal(leg)">
                                    <i nz-icon nzType="file-text" nzTheme="outline"></i>
                                    Upload Checklists
                                </button>
                            </ng-container>
                            <ng-container *ngIf="trip?.active_leg_id == leg?.leg_id && firstActiveLeg?.status == 'active' && feUtil.roleService.hasAccess([0,1,2,5,6,7])">
                                <button nz-button nzType="default" nzSize="small" nz-popconfirm [nzLoading]="loaders['endLeg']"
                                    nzPopconfirmTitle="Are you sure you want to end this trip?" nzPopconfirmPlacement="bottom" (nzOnConfirm)="endLeg(leg)">
                                    <i nz-icon nzType="stop" nzTheme="outline"></i>
                                    End Trip
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </nz-timeline-item>
    </nz-timeline>

    <ng-template #firstLegTemplate>
        <div class="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center shadow-lg">
            <i nz-icon nzType="home" nzTheme="outline" class="text-white text-sm"></i>
        </div>
    </ng-template>

    <ng-template #activeLegTemplate>
        <div class="w-8 h-8 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full flex items-center justify-center shadow-lg">
            <i nz-icon nzType="environment" nzTheme="outline" class="text-white text-sm"></i>
        </div>
    </ng-template>

    <ng-template #completedLegTemplate>
        <div class="w-8 h-8 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full flex items-center justify-center shadow-lg">
            <i nz-icon nzType="check-circle" nzTheme="outline" class="text-white text-sm"></i>
        </div>
    </ng-template>

    <ng-template #discardLegTemplate>
        <div class="w-8 h-8 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-lg">
            <i nz-icon nzType="close-circle" nzTheme="outline" class="text-white text-sm"></i>
        </div>
    </ng-template>
</nz-card>

<nz-modal [(nzVisible)]="modal['isSensorWarning']" nzTitle="Sensor Removal" [nzFooter]="null"
    (nzOnCancel)="modal['isSensorWarning'] = false">
    <ng-container *nzModalContent>
        <div class="text-center py-4">
            <i nz-icon nzType="warning" nzTheme="twotone" class="text-6xl text-warning mb-4"></i>
            <h3 class="text-lg font-semibold mb-2">Confirm Sensor Removal</h3>
            <p class="text-gray-600 mb-6">
                Please ensure that the sensor has been successfully removed from the truck before ending this trip.
            </p>
            <div class="flex justify-center gap-3">
                <button nz-button nzType="default" (click)="modal['isSensorWarning'] = false" class="px-6">
                    Cancel
                </button>
                <button nz-button nzType="primary" nzDanger class="px-6" (click)="endTrip()">
                    Yes, End Trip
                </button>
            </div>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modal['fileUploadModal']" nzTitle="Upload Checklist Documents" (nzOnCancel)="skipChecklists()"
    [nzWidth]="700" nzCentered nzOkText="Submit" nzCancelText="Skip for now" (nzOnOk)="saveChecklists()" [nzOkLoading]="loaders['uploadChecklist']"
    [nzMaskClosable]="false" [nzClosable]="false" [nzKeyboard]="false" [nzBodyStyle]="{ 'padding-top': '8px' }">
    <ng-container *nzModalContent>
        <!-- upload with tabs -->
        <nz-tabset>
            <nz-tab nzTitle="Loading Checklist">
                <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
                    <div class="flex items-center gap-3 mb-4">
                        <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                            <i nz-icon nzType="up-circle" nzTheme="outline" class="text-white text-lg"></i>
                        </div>
                        <div>
                            <h4 class="text-lg font-semibold text-gray-800">Loading Checklist</h4>
                            <p class="text-sm text-gray-600">Documents for loading verification</p>
                        </div>
                    </div>
                    <nz-upload 
                        nzType="drag" 
                        [nzMultiple]="true" 
                        [(nzFileList)]="loadingChecklistFiles"
                        [nzBeforeUpload]="beforeUploadLoadingPdf"
                        [nzAccept]="['.pdf', '.jpeg', '.jpg', '.png', '.xlsx', '.xls', '.csv']">
                        <div>
                            <i nz-icon nzType="file-pdf" nzTheme="outline" class="text-4xl text-blue-500"></i>
                        </div>
                        <p>Drop PDF files here or <span class="text-blue-600 font-medium">browse</span></p>
                    </nz-upload>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Unloading Checklist">
                <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
                    <div class="flex items-center gap-3 mb-4">
                        <div class="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                            <i nz-icon nzType="down-circle" nzTheme="outline" class="text-white text-lg"></i>
                        </div>
                        <div>
                            <h4 class="text-lg font-semibold text-gray-800">Unloading Checklist</h4>
                            <p class="text-sm text-gray-600">Documents for unloading verification</p>
                        </div>
                    </div>
                    <nz-upload 
                        nzType="drag" 
                        [nzMultiple]="true" 
                        [(nzFileList)]="unloadingChecklistFiles"
                        [nzBeforeUpload]="beforeUploadUnloadingPdf"
                        [nzAccept]="['.pdf', '.jpeg', '.jpg', '.png', '.xlsx', '.xls', '.csv']">
                        <div>
                            <i nz-icon nzType="file-pdf" nzTheme="outline" class="text-4xl text-green-500"></i>
                        </div>
                        <p>Drop PDF files here or <span class="text-green-600 font-medium">browse</span></p>
                    </nz-upload>
                </div>
            </nz-tab>
        </nz-tabset>
        <!-- count -->
        <div class="bg-gray-50 rounded-lg p-4 mt-2 border border-gray-200">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-4">
                    <div class="flex items-center gap-2">
                        <i nz-icon nzType="file-text" nzTheme="outline" class="text-blue-600"></i>
                        <span class="text-sm font-medium text-gray-700">Loading: {{ loadingChecklistFiles.length }}
                            files</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <i nz-icon nzType="file-text" nzTheme="outline" class="text-green-600"></i>
                        <span class="text-sm font-medium text-gray-700">Unloading: {{ unloadingChecklistFiles.length }}
                            files</span>
                    </div>
                </div>
                <div class="text-sm text-gray-500">
                    Total: {{ loadingChecklistFiles.length + unloadingChecklistFiles.length }} files
                </div>
            </div>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modal['fileViewModal']" nzTitle="Checklist Documents" [nzBodyStyle]="{ 'padding-top': '8px' }"
    (nzOnCancel)="modal['fileViewModal'] = false" [nzFooter]="null" [nzWidth]="700" nzCentered>
    <ng-container *nzModalContent>
        <app-checklist-view [checklist]="checklist"></app-checklist-view>
    </ng-container>
</nz-modal>

<ng-template #timelineTitle>
    <div class="flex items-center justify-between">
        <div class="text-sm font-bold">Trip Timeline</div>
        <div class="flex items-center gap-2">
            <ng-container *ngIf="firstActiveLeg?.leg_id == trip?.active_leg_id && firstActiveLeg?.status == 'active'">
                <button nz-button nzType="primary" [nzLoading]="loaders['inventoryMovement']" nzSize="small" (nzOnConfirm)="inventoryMovementHandler('paused')"
                    aria-label="Start Inventory Movement" nz-popconfirm nzPopconfirmTitle="Are you sure you want to start the movement?" nzPopconfirmPlacement="left">
                    <i nz-icon nzType="play-circle" nzTheme="twotone" class="text-xs" ></i>
                    <span class="font-semibold text-xs">Start Movement</span>
                </button>
            </ng-container>
            <ng-container *ngIf="firstActiveLeg?.leg_id == trip?.active_leg_id && firstActiveLeg?.status == 'paused' && feUtil.roleService.hasAccess([0,1,2,5,6,7])">
                <button nz-button nzType="default" [nzLoading]="loaders['inventoryMovement']" nzSize="small" (nzOnConfirm)="inventoryMovementHandler('active')"
                    aria-label="End Inventory Movement" nz-popconfirm nzPopconfirmTitle="Are you sure you want to end the movement?" nzPopconfirmPlacement="left">
                    <i nz-icon nzType="pause-circle" nzTheme="twotone" class="text-xs"></i>
                    <span class="font-semibold text-xs">End Movement</span>
                </button>
            </ng-container>
        </div>
    </div>
</ng-template>